"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_model_1 = require("prosemirror-model");
exports.DOMParser = prosemirror_model_1.DOMParser;
var document = window.document;
exports.document = document;
function setDocument(options) {
    if (!options.document) {
        options.document = document;
    }
}
var DeclareDOMSerializer = /** @class */ (function (_super) {
    __extends(DeclareDOMSerializer, _super);
    function DeclareDOMSerializer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeclareDOMSerializer;
}(prosemirror_model_1.DOMSerializer));
var SylDOMSerializer = /** @class */ (function (_super) {
    __extends(SylDOMSerializer, _super);
    function SylDOMSerializer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SylDOMSerializer.fromSchema = function (schema) {
        return (schema.cached.domSerializer ||
            (schema.cached.domSerializer = new prosemirror_model_1.DOMSerializer(DeclareDOMSerializer.nodesFromSchema(schema), DeclareDOMSerializer.marksFromSchema(schema))));
    };
    // @ts-ignore
    // serializeFragment(
    //   fragment: Fragment,
    //   options: Options = {},
    //   target: DocumentFragment
    // ): DocumentFragment {
    //   setDocument(options)
    //   // @ts-ignore
    //   return super.serializeFragment(fragment, options, target)
    // }
    SylDOMSerializer.prototype.serializeNode = function (node, options) {
        if (options === void 0) { options = {}; }
        setDocument(options);
        return _super.prototype.serializeNode.call(this, node, options);
    };
    SylDOMSerializer.prototype.serializeMark = function (mark, inline, options) {
        if (options === void 0) { options = {}; }
        setDocument(options);
        // @ts-ignore
        return _super.prototype.serializeMark.call(this, mark, inline, options);
    };
    return SylDOMSerializer;
}(DeclareDOMSerializer));
exports.DOMSerializer = SylDOMSerializer;
//# sourceMappingURL=index.js.map